import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import LeadForm from '@/components/LeadForm';

const ContactPage = () => {
  return (
    <div data-testid="contact-page">
      {/* Hero */}
      <section className="pt-32 pb-16 bg-[#FAF9F6]">
        <div className="container-main">
          <div className="max-w-3xl">
            <span className="text-xs uppercase tracking-[0.3em] text-[#C5A065] mb-4 block">
              Get In Touch
            </span>
            <h1
              data-testid="contact-page-title"
              className="font-heading text-4xl md:text-5xl text-[#2D2D2D] mb-6"
            >
              Let's Start Your Project
            </h1>
            <p className="text-[#6E6E6E] text-lg leading-relaxed">
              Ready to transform your space? Fill out the form below or contact
              us directly. We'll respond within 24 hours to schedule your free
              consultation.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="section-padding bg-white">
        <div className="container-main">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
            {/* Contact Info */}
            <div>
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-8">
                Contact Information
              </h2>

              <div className="space-y-8 mb-12">
                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 rounded-full bg-[#FAF9F6] flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-6 h-6 text-[#C5A065]" />
                  </div>
                  <div>
                    <h4 className="font-medium text-[#2D2D2D] mb-2 text-lg">
                      Our Location
                    </h4>
                    <p className="text-[#6E6E6E]">New York, USA</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 rounded-full bg-[#FAF9F6] flex items-center justify-center flex-shrink-0">
                    <Phone className="w-6 h-6 text-[#C5A065]" />
                  </div>
                  <div>
                    <h4 className="font-medium text-[#2D2D2D] mb-2 text-lg">
                      Phone Number
                    </h4>
                    <a
                      href="tel:+18888801455"
                      data-testid="contact-phone"
                      className="text-[#6E6E6E] hover:text-[#C5A065] transition-colors text-lg"
                    >
                      +1-888-880-1455
                    </a>
                    <p className="text-sm text-[#6E6E6E] mt-1">
                      Click to call directly
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 rounded-full bg-[#FAF9F6] flex items-center justify-center flex-shrink-0">
                    <Mail className="w-6 h-6 text-[#C5A065]" />
                  </div>
                  <div>
                    <h4 className="font-medium text-[#2D2D2D] mb-2 text-lg">
                      Email Address
                    </h4>
                    <a
                      href="mailto:support@decorsgenius.store"
                      data-testid="contact-email"
                      className="text-[#6E6E6E] hover:text-[#C5A065] transition-colors"
                    >
                      support@decorsgenius.store
                    </a>
                    <p className="text-sm text-[#6E6E6E] mt-1">
                      We respond within 24 hours
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 rounded-full bg-[#FAF9F6] flex items-center justify-center flex-shrink-0">
                    <Clock className="w-6 h-6 text-[#C5A065]" />
                  </div>
                  <div>
                    <h4 className="font-medium text-[#2D2D2D] mb-2 text-lg">
                      Business Hours
                    </h4>
                    <p className="text-[#6E6E6E]">
                      Monday - Saturday: 9:00 AM - 6:00 PM
                    </p>
                    <p className="text-[#6E6E6E]">Sunday: Closed</p>
                  </div>
                </div>
              </div>

              {/* Quote */}
              <div className="bg-[#FAF9F6] p-8">
                <p className="font-accent text-xl italic text-[#4A4A4A] leading-relaxed">
                  "Every home has a story waiting to be told. Let us help you
                  write yours through thoughtful, personalized design."
                </p>
                <p className="text-[#C5A065] mt-4 text-sm">— Decors Genius Team</p>
              </div>
            </div>

            {/* Form */}
            <div className="bg-[#FAF9F6] p-8 md:p-12">
              <h2 className="font-heading text-2xl text-[#2D2D2D] mb-2">
                Request Your Free Consultation
              </h2>
              <p className="text-[#6E6E6E] mb-8">
                Fill out the form below and we'll get back to you shortly.
              </p>
              <LeadForm />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
